import {
  BillerMaster,
  RequirementFlag,
} from "features/bbps/biller/billerTypes";
import { useEffect, useState } from "react";
import billerHttp from "services/axios.services/instances/billerHttp";
import { useBillValidation } from "../billValidation/useBillValidation";

interface BillerListState {
  loading: boolean;
  error?: string;
  billers: BillerMaster[];
}

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 min
const billerCache = new Map<
  string,
  { data: BillerMaster[]; cachedAt: number }
>();

export function useBillerList(categoryApiName?: string) {
  const [state, setState] = useState<BillerListState>({
    loading: false,
    billers: [],
  });

  const {
    // validateBill,
    resetValidation,
    // loading: validationLoading,
    // error: validationError,
    // data: validationData,
    // isBillValidationSuccess,
  } = useBillValidation();

  useEffect(() => {
    if (!categoryApiName) return;

    const key = categoryApiName;
    resetValidation();
    // cache hit
    const cached = billerCache.get(key);
    const now = Date.now();
    if (cached && now - cached.cachedAt < CACHE_TTL_MS) {
      setState({ loading: false, billers: cached.data });
      return;
    }

    let cancelled = false;

    async function load() {
      setState((s) => ({ ...s, loading: true, error: undefined }));
      try {
        const res = await billerHttp.get<BillerMaster[]>(
          // `/api/Biller/GetBillerByCategory/${categoryApiName}`
          `/api/v1/biller/category/${categoryApiName}`,
        );

        if (cancelled) return;

        billerCache.set(key, { data: res.data, cachedAt: now });
        setState({ loading: false, billers: res.data });
      } catch (err: any) {
        if (cancelled) return;
        setState({
          loading: false,
          billers: [],
          error: err?.message || "Failed to load billers",
        });
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, [categoryApiName]);

  return state;
}

// ------------------ Capability helpers ------------------

export function isMandatory(flag?: RequirementFlag) {
  return flag?.toUpperCase() === "MANDATORY";
}

export function isMandatoryOrOptional(flag?: RequirementFlag) {
  return (
    flag?.toUpperCase() === "MANDATORY" || flag?.toUpperCase() === "OPTIONAL"
  );
}
export function isNotSupported(flag?: RequirementFlag) {
  return flag?.toUpperCase() === "NOT_SUPPORTED";
}
